import React, { useEffect, ReactElement } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Params, useParams } from 'react-router-dom';
import { Dispatch } from 'redux';

import { HashTag } from '../../../../types/entity.types';
import { RootState } from '../../../../types/state/root.types';
import { TribeState } from '../../../../types/state/tribe.types';

import { requestViewHashtagOccurrences } from '../../../../api/administration/administration.actions';

import TribeHashtags from '../../../../components/screens/programme/tribe/tribe-hashtags/TribeHashtags';

const TribeHashtagsContainer = (): ReactElement => {
  const { hashtagOccurrences } = useSelector(({ tribe }: RootState): TribeState => tribe);

  const dispatch: Dispatch = useDispatch();

  const { programmeExternalReference }: Readonly<Params> = useParams();

  useEffect((): void => {
    // @ts-expect-error TODO: Fix after adding types to administration actions
    dispatch(requestViewHashtagOccurrences({ programmeExternalReference }));
  }, [dispatch, programmeExternalReference]);

  const sortedHashtags: HashTag[] = [...hashtagOccurrences].sort((hashtagOne: HashTag, hashtagTwo: HashTag): number => {
    const occurrenceOne: string | undefined = hashtagOne.occurrence;
    const occurrenceTwo: string | undefined = hashtagTwo.occurrence;

    if (!occurrenceOne || !occurrenceTwo) return 0;

    if (occurrenceOne > occurrenceTwo) return -1;
    if (occurrenceOne < occurrenceTwo) return 1;
    return 0;
  });

  return <TribeHashtags hashtags={sortedHashtags} />;
};

export default TribeHashtagsContainer;
